import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GaCountrySelectModule } from 'gain-lib/country-select';
import { DeprecatedInformationDialogModule } from 'gain-lib/deprecated-information-dialog/deprecated-information-dialog.module';
import { GaSidePanelModalModule } from 'gain-lib/dialog/dialog.module';
import { GaFormsModule } from 'gain-lib/forms/src/forms.module';
import { GaPageEditingModule } from 'gain-lib/ga-page-editing/ga-page-editing.module';
import { GaProcessMonitorModule } from 'gain-lib/ga-process-monitor/process-monitor.module';
import { GaTableModule } from 'gain-lib/ga-table';
import { GaGeographyModule } from 'gain-lib/geography';
import { GaHeaderModule } from 'gain-lib/header';
import { GaHelpIconComponent } from 'gain-lib/help-icon/help-icon.component';
import { GaIconModule } from 'gain-lib/icon';
import { InformationSidePanelModalModule } from 'gain-lib/information-side-panel-modal/information-side-panel-modal.module';
import { PageModule } from 'gain-lib/page/page.module';
import { GaSideNavigationModule } from 'gain-lib/side-navigation';
import { GaTileModule } from 'gain-lib/tile';
import { WholeNumbersModule } from 'gain-lib/whole-numbers/whole-numbers.module';
import { YesNoPipe } from 'gain-web/app/clients/client-reporting/pipes/yes-no.pipe';
import { BatchStatusDisplayPipe } from 'gain-web/lib/enums/typed-enum-display-pipes/batch-status-display.pipe';
import { CalculationStatusDisplayPipe } from 'gain-web/lib/enums/typed-enum-display-pipes/calculation-status-display.pipe';
import { PlanTypeDisplayPipe } from 'gain-web/lib/enums/typed-enum-display-pipes/plan-type-display.pipe';
import { TransactionStatusDisplayPipe } from 'gain-web/lib/enums/typed-enum-display-pipes/transaction-status-display.pipe';
import { UntypedEnumDisplayPipe } from 'gain-web/lib/enums/untyped-enum-display.pipe';
import { GainPercentPipe } from 'gain-web/lib/percent/gain-percent.pipe';
import { PlanTypesModule } from 'gain-web/lib/plan-types/plan-types.module';
import { GaDateTimeModule } from 'gain-web/shared-modules/ga-date-time/ga-date-time.module';
import { GainGeographyModule } from 'gain-web/shared-modules/geography/gain-geography.module';
import { GainMoneyModule } from 'gain-web/shared-modules/money/money.module';
import { FormatDisplayPipe } from '../../lib/pipes/format-display.pipe';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { ClickOutsideModule } from '../click-outside/click-outside.module';
import { DragDropModule } from '../drag-drop/drag-drop.module';
import { EmphasizeCharactersModule } from '../emphasize-characters/emphasize-characters.module';
import { GaClipboardModule } from '../ga-clipboard/ga-clipboard.module';
import { GaConfirmDialogModule } from '../ga-confirm-dialog/ga-confirm-dialog.module';
import { GaRegionSelectModule } from '../ga-region-select/region-select.module';
import { GaRequiredAsteriskComponent } from '../ga-required-asterisk/ga-required-asterisk.component';
import { GaTableCellInputComponent } from '../ga-table-cell-input/ga-table-cell-input.component';
import { GaTableDeleteModule } from '../ga-table-delete/ga-table-delete.module';
import { GaInputFormFieldComponent } from '../input-form-field/input-form-field.component';
import { LimitDecimalsModule } from '../limit-decimals/limit-decimals.module';
import { MaterialUIModule } from '../material-ui/material-ui.module';
import { RunCalculationEmployeeInformationModule } from '../run-calculation-employee-information-header/run-calculation-employee-information.module';
import { GaGAINSelectFormFieldModule } from '../select-form-field/select-form-field.module';
import { SpecificCountryRegionTaxRatesPageComponent } from '../specific-country-region-tax-rates-page/specific-country-region-tax-rates-page.component';
import { CamelCaseToSentencePipe } from '../text-format/camelCase-toSentence.pipe';

@NgModule({
  declarations: [
    CamelCaseToSentencePipe,
    FormatDisplayPipe,
    SpecificCountryRegionTaxRatesPageComponent,
    YesNoPipe,
  ],
  imports: [
    BatchStatusDisplayPipe,
    BreadcrumbsModule,
    CalculationStatusDisplayPipe,
    ClickOutsideModule,
    CommonModule,
    DeprecatedInformationDialogModule,
    DragDropModule,
    EmphasizeCharactersModule,
    FormsModule,
    GaClipboardModule,
    GaConfirmDialogModule,
    GaConfirmDialogModule,
    GaCountrySelectModule,
    GaDateTimeModule,
    GaGAINSelectFormFieldModule,
    GaGeographyModule,
    GaHeaderModule,
    GaHelpIconComponent,
    GaIconModule,
    GainGeographyModule,
    GainMoneyModule,
    GainPercentPipe,
    GaInputFormFieldComponent,
    GaPageEditingModule,
    GaProcessMonitorModule,
    GaRegionSelectModule,
    GaRequiredAsteriskComponent,
    GaSideNavigationModule,
    GaSidePanelModalModule,
    GaTableCellInputComponent,
    GaTableDeleteModule,
    GaTableModule,
    GaTileModule,
    GaFormsModule,
    InformationSidePanelModalModule,
    LimitDecimalsModule,
    WholeNumbersModule,
    MaterialUIModule,
    MatTooltipModule,
    PageModule,
    PlanTypeDisplayPipe,
    ReactiveFormsModule,
    RunCalculationEmployeeInformationModule,
    TransactionStatusDisplayPipe,
    UntypedEnumDisplayPipe,
    PlanTypesModule,
  ],
  exports: [
    BatchStatusDisplayPipe,
    BreadcrumbsModule,
    CalculationStatusDisplayPipe,
    CamelCaseToSentencePipe,
    DeprecatedInformationDialogModule,
    DragDropModule,
    EmphasizeCharactersModule,
    FormatDisplayPipe,
    FormsModule,
    GaClipboardModule,
    GaConfirmDialogModule,
    GaCountrySelectModule,
    GaDateTimeModule,
    GaGAINSelectFormFieldModule,
    GaGeographyModule,
    GaHeaderModule,
    GaHelpIconComponent,
    GaIconModule,
    GainGeographyModule,
    GainMoneyModule,
    GainPercentPipe,
    GaInputFormFieldComponent,
    GaPageEditingModule,
    GaProcessMonitorModule,
    GaRegionSelectModule,
    GaRequiredAsteriskComponent,
    GaSideNavigationModule,
    GaSidePanelModalModule,
    GaTableCellInputComponent,
    GaTableDeleteModule,
    GaTableModule,
    GaTileModule,
    InformationSidePanelModalModule,
    LimitDecimalsModule,
    WholeNumbersModule,
    MaterialUIModule,
    MatTooltipModule,
    PageModule,
    PlanTypeDisplayPipe,
    ReactiveFormsModule,
    RunCalculationEmployeeInformationModule,
    SpecificCountryRegionTaxRatesPageComponent,
    TransactionStatusDisplayPipe,
    UntypedEnumDisplayPipe,
    YesNoPipe,
    PlanTypesModule,
    GaFormsModule,
  ],
  providers: [
    FormatDisplayPipe,
    CalculationStatusDisplayPipe,
    PlanTypeDisplayPipe,
    TransactionStatusDisplayPipe,
  ],
})
export class SharedEssentialsModule {}
